import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    textInput: {
        minWidth: "230px",
    },
}));
